/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Backbone = window.Backbone;

exports.default = Backbone.Model.extend({
  defaults: {
    taxonomy: null,
    slug: '',
    name: '',
    selected: false
  }
});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Filter = __webpack_require__(5);

var _Filter2 = _interopRequireDefault(_Filter);

var _Filters = __webpack_require__(6);

var _Filters2 = _interopRequireDefault(_Filters);

var _SelectedFilters = __webpack_require__(7);

var _SelectedFilters2 = _interopRequireDefault(_SelectedFilters);

var _SelectedFilters3 = __webpack_require__(9);

var _SelectedFilters4 = _interopRequireDefault(_SelectedFilters3);

var _Items = __webpack_require__(10);

var _Items2 = _interopRequireDefault(_Items);

var _Items3 = __webpack_require__(12);

var _Items4 = _interopRequireDefault(_Items3);

__webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sfspcaUserContent = window.sfspcaUserContent;
var _ = window._;
var $ = jQuery;
var Backbone = window.Backbone;

window.sfscpaVent = _.extend({}, Backbone.Events);

$(document).on('sfspca/user-stories/grid-init', function () {

  if ($('.js-userContent').length > 1) {
    console.log('There are more than one view. Removing the surplus!');
    $('.js-userContent').not(':first()').remove();
  }

  if ($('.js-userContent').data('user-story-init')) {
    return;
  }

  $('.js-userContent').data('user-story-init', 1);

  var selectedFiltersCollection = new _SelectedFilters4.default();

  new _SelectedFilters2.default({
    collection: selectedFiltersCollection
  });

  _.each(sfspcaUserContent.filters, function (filter) {
    var fieldset = $('<fieldset />').html(new _Filter2.default({
      collection: new _Filters2.default(filter.terms),
      taxonomy: filter.taxonomy
    }).$el);

    $('.js-userContent__filters').append(fieldset);
  });

  new _Items4.default({
    collection: new _Items2.default(),
    filters: selectedFiltersCollection
  });
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Backbone = window.Backbone;
var $ = jQuery;
var _ = window._;

var Filter = Backbone.View.extend({
  tagName: 'span',
  template: _.template('<%= name %>'),
  events: {
    'click': 'onChange'
  },

  initialize: function initialize() {
    this.render();
  },

  render: function render() {
    if (this.model.get('selected')) {
      this.$el.addClass('is-selected');
    }

    this.$el.html(this.template(this.model.toJSON()));
    return this.$el;
  },

  onChange: function onChange() {
    window.sfscpaVent.trigger(this.model.get('selected') ? 'delete-filter' : 'add-filter', this.model);
  }
});

exports.default = Backbone.View.extend({
  tagName: 'span',
  className: 'userContent__filter',

  initialize: function initialize(options) {
    this.taxonomy = options.taxonomy;
    this.render();

    this.collection.on('all', this.render, this);
  },

  render: function render() {
    var _this = this;

    this.$el.html('<span class="userContent__filterTaxonomy">-- ' + this.taxonomy.niceName + ' --</span>');

    var filterDropdown = $('<span class="userContent__filtersDropdown"/>');

    this.collection.each(function (filter) {
      filter.set('taxonomy', _this.taxonomy);

      filterDropdown.append(new Filter({ model: filter }).$el);

      if (filter.get('selected')) {
        window.sfscpaVent.trigger('add-filter', filter);
      }
    });

    this.$el.append(filterDropdown);
    return this;
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter = __webpack_require__(0);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backbone = window.Backbone;

exports.default = Backbone.Collection.extend({
  model: _Filter2.default,
  initialize: function initialize() {
    window.sfscpaVent.on('delete-filter', function (filter) {
      filter.set('selected', false);
    });

    window.sfscpaVent.on('add-filter', function (filter) {
      filter.set('selected', true);
    });
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SelectedFilter = __webpack_require__(8);

var _SelectedFilter2 = _interopRequireDefault(_SelectedFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backbone = window.Backbone;

exports.default = Backbone.View.extend({
  el: '.js-userContent__selectedFilters',

  events: {},

  initialize: function initialize(options) {
    this.taxonomy = options.taxonomy;
    this.render();
    this.collection.on('all', this.render, this);
  },

  render: function render() {
    var _this = this;

    this.$el.empty();

    this.collection.each(function (filter) {
      _this.$el.append(new _SelectedFilter2.default({
        model: filter
      }).$el);
    });

    return this;
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ = window._;
var Backbone = window.Backbone;
var $ = jQuery;

exports.default = Backbone.View.extend({
  tagName: 'span',
  className: 'userContent__deleteFilter__item',
  template: _.template($('#userContent-selectedFilters-tpl').html()),
  events: {
    'click .js-userContent__deleteFilter': 'removeFilter'
  },

  initialize: function initialize() {
    this.render();
  },

  render: function render() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  },

  removeFilter: function removeFilter(e) {
    e.preventDefault();
    window.sfscpaVent.trigger('delete-filter', this.model);
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter = __webpack_require__(0);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backbone = window.Backbone;

exports.default = Backbone.Collection.extend({
  model: _Filter2.default,
  initialize: function initialize() {
    var _this = this;

    window.sfscpaVent.on('add-filter', function (filter) {
      _this.add(filter);
    });

    window.sfscpaVent.on('delete-filter', function (filter) {
      _this.remove(filter);
    });
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(11);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = window._;
var Backbone = window.Backbone;
var sfspcaUserContent = window.sfspcaUserContent;

exports.default = Backbone.PageableCollection.extend({
  model: _Item2.default,
  url: sfspcaUserContent.restURL,
  searchTerm: '',
  filters: [],

  syncXhr: null,
  alterHistory: sfspcaUserContent.alterHistory,

  initialize: function initialize() {
    // this.fetch();
  },

  parseRecords: function parseRecords(resp) {
    return resp.items;
  },

  parseState: function parseState(resp) {
    return {
      totalRecords: resp.total
    };
  },

  searchQuery: function searchQuery(term) {
    this.searchTerm = term;
  },

  updateFilters: function updateFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    this.filters = filters;
  },

  sync: function sync(method, collection) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    options.data = _.extend({
      'search-stories': '',
      filters: []
    }, options.data);

    console.log(this.searchTerm);
    if (this.searchTerm !== '') {
      options.data['search-stories'] = this.searchTerm;
    }

    if (this.filters.length) {
      options.data.filters = this.filters;
    }

    try {
      this.syncXhr.abort();
    } catch (err) {
      //
    }

    this.syncXhr = Backbone.PageableCollection.prototype.sync.apply(this, [method, collection, options]);

    this.syncXhr.done(function () {
      if (_this.alterHistory) {
        _this.alterHash(options.data);
      }
    });

    return this.syncXhr;
  },

  loadMore: function loadMore() {
    this.getNextPage();
  },

  alterHash: function alterHash(data) {
    var hash = {
      'search-stories': data['search-stories'],
      page: this.state.currentPage,
      filters: []
    };

    var filters = {};

    if (data.filters.length) {
      _.each(data.filters, function (filter) {
        filters[filter.taxonomy.name] = filters[filter.taxonomy.name] || [];

        filters[filter.taxonomy.name].push(filter.id);
      });

      _.each(Object.keys(filters), function (key) {
        hash.filters.push(key + '=' + filters[key].join(','));
      });

      hash.filters = hash.filters.join(';');
    }

    var href = [];

    _.each(Object.keys(hash), function (key) {
      if (hash[key] !== '') {
        href.push(key + '=' + hash[key]);
      }
    });

    var oldHref = window.location.href;
    var oldSearch = window.location.search;

    oldHref = oldHref.replace(oldSearch, '');
    oldHref += '?' + href.join('&');

    if (window.history && window.history.pushState) {
      window.history.pushState({}, '', oldHref);
    }
  },

  state: {
    pageSize: parseInt(sfspcaUserContent.postsPerPage, 10),
    currentPage: parseInt(sfspcaUserContent.currentPage, 10) || 1
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Backbone = window.Backbone;

exports.default = Backbone.Model.extend({
  defaults: {
    thumb: '',
    name: '',
    title: '',
    excerpt: '',
    shareCount: 0,
    type: 'text',
    permalink: '',
    tags: []
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(13);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backbone = window.Backbone;
var _ = window._;
var $ = jQuery;

exports.default = Backbone.View.extend({
  events: {
    'click .js-userContent__loadMore': 'loadMore',
    'keyup .js-userContent__search': 'search',
    'search .js-userContent__search': 'search'
  },

  el: $('.js-userContent'),
  emptyOnSync: true,

  initialize: function initialize(options) {
    this.filtersColection = options.filters;
    this.grid = this.$el.find('.js-userContent__grid');

    this.initMasonry();

    if (this.filtersColection) {
      this.filtersColection.on('all', this.filtersUpdate, this);
      this.filtersUpdate();
    } else {
      this.collection.fetch();
    }

    this.collection.on('sync', this.onSync, this);
  },

  initMasonry: function initMasonry() {
    this.masonry = this.grid.masonry({
      itemSelector: '.userContent__item',
      percentPosition: true
    });
  },

  onSync: function onSync() {
    this.$el.removeClass('is-loading is-loading-alt is-loading-filters');

    if (this.emptyOnSync) {
      this.grid.masonry('remove', $('.userContent__item'));
    }

    this.collection.each(this.render, this);

    this.emptyOnSync = true;
    this.maybeShowPagination();

    if (this.collection.length === 0) {
      this.showNotFound();
    }
  },

  filtersUpdate: function filtersUpdate(action) {
    this.startLoading(true);

    this.collection.updateFilters(this.filtersColection.toJSON());

    this.collection.searchQuery($('.js-userContent__search', this.el).val());

    if (action === 'update') {
      this.collection.getPage(1);
    } else {
      this.collection.fetch();
    }
  },

  maybeShowPagination: function maybeShowPagination() {
    if (this.collection.hasNextPage()) {
      this.$el.addClass('has-next-page');
    } else {
      this.$el.removeClass('has-next-page');
    }
  },

  render: function render(item) {
    var _this = this;

    var newItem = new _Item2.default({
      model: item
    }).$el;

    this.grid.masonry().append(newItem).masonry('appended', newItem).masonry();

    this.grid.imagesLoaded().progress(function () {
      _this.grid.masonry('layout');
    });

    return this;
  },

  showNotFound: function showNotFound() {
    var notFound = _.template($('#userContent-itemsNotFound-tpl').html());

    this.grid.empty().masonry().append(notFound).masonry('appended', notFound).masonry();
  },

  search: function search(e) {
    e.preventDefault();
    this.collection.searchQuery(e.currentTarget.value);
    this.startLoading(true);

    this.collection.getPage(1);
  },

  loadMore: function loadMore(e) {
    e.preventDefault();
    this.emptyOnSync = false;
    this.startLoading();
    this.collection.loadMore();
  },

  startLoading: function startLoading() {
    var isFilterLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var loadingClass = 'is-loading';

    if (Math.random() > 0.5) {
      loadingClass += ' is-loading-alt';
    }

    if (isFilterLoading) {
      loadingClass += ' is-loading-filters';
    }

    this.$el.addClass(loadingClass);
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ = window._;
var Backbone = window.Backbone;
var $ = jQuery;

exports.default = Backbone.View.extend({
  tagName: 'div',
  template: _.template($('#userContent-item-tpl').html()),
  className: 'userContent__item',
  events: {},

  initialize: function initialize() {
    this.render();
  },

  render: function render() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = jQuery;

var sfspcaUserContent = window.sfspcaUserContent;

var form = $('.js-submitUserContent');

var progress = $('.progressBar', form);
var bar = $('.bar', form);
var percent = $('.percent', form);

var submitBtn = $('button[type="submit"]', form);

$('.js-toggleUserStorySubmit').on('click', function () {
  $('body').toggleClass('user-form-is-visible');

  if ($('body').hasClass('user-form-is-visible')) {
    $('.js-userContentSubmitPopup').css({
      top: $(window).scrollTop() + 30
    });
  }

  return false;
});

$('.js-closeUserStorySubmit').on('click', function () {
  $('body').removeClass('user-form-is-success');
  return false;
});

var successPopup = $('.userContentSubmit__success');

function clearFormProgress() {
  var percentVal = '0%';

  bar.width(percentVal);
  percent.html(percentVal);

  progress.hide();
}

var beforeSend = function beforeSend(xhr) {
  xhr.setRequestHeader('X-WP-Nonce', sfspcaUserContent.nonce);

  progress.show();

  form.addClass('is-submitting');
  submitBtn.attr('disabled', true);
};

var onUploadProgress = function onUploadProgress(event, position, total, percentComplete) {
  var percentVal = percentComplete + '%';

  bar.width(percentVal);
  percent.html(percentVal);
};

var onSuccess = function onSuccess() {
  var percentVal = '100%';

  bar.width(percentVal);
  percent.html(percentVal);

  $('.js-toggleUserStorySubmit').first().click();
  $('body').addClass('user-form-is-success');

  $('body, html').animate({
    scrollTop: successPopup.offset().top
  });

  form.parsley().reset();
  form.clearForm().resetForm();
};

var onComplete = function onComplete() {
  clearFormProgress();
  form.removeClass('is-submitting');
  submitBtn.removeAttr('disabled');
};

var fileUploader = $('.js-userContentFileUpload');
var fileList = $('.js-userContentFiles', fileUploader);

$('input[type="file"]', fileUploader)[0].onchange = function () {
  fileList.empty();
  if (this.files.length) {
    $.each(this.files, function (i, file) {
      fileList.append('<span>' + file.name + '</span>');
    });
  }
};

$('.js-submitUserContent').parsley().on('form:submit', function () {
  $(form).ajaxSubmit({
    url: sfspcaUserContent.restURL,
    beforeSend: beforeSend,
    uploadProgress: onUploadProgress,
    success: onSuccess,
    complete: onComplete
  });
  return false;
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// userContent.min.js